import { BreadcrumbItem } from "../../_components/Molecules/Breadcrumbs"

export interface GenerateBreadcrumbsParams {
    category?: string
    subCategory?: string[]
    slug?: string[]
    product?: {
        categoryUri: string
        categoryName: string[]
    }
}

const CATEGORIES_URI = "categories"

/**
 * Generates breadcrumbs for different types of pages.
 *
 * @param params - Object containing relevant data for generating breadcrumbs.
 * @returns An array of BreadcrumbItem objects for rendering breadcrumbs.
 */
export const generateBreadcrumbs = ({
    category,
    subCategory,
    slug,
    product
}: GenerateBreadcrumbsParams): BreadcrumbItem[] => {
    // Home breadcrumb
    const breadcrumbs: BreadcrumbItem[] = [
        {
            name: "Home",
            url: ""
        }
    ]

    // Case: Category Pages
    if (category) {
        breadcrumbs.push({
            name: category.charAt(0).toUpperCase() + category.slice(1),
            url: `/${CATEGORIES_URI}/${category}`
        })

        if (subCategory && subCategory.length > 0) {
            breadcrumbs.push(
                ...subCategory.map((segment, index) => ({
                    name: segment.charAt(0).toUpperCase() + segment.slice(1),
                    url: `/${CATEGORIES_URI}/${category}/${(subCategory ?? [])
                        .slice(0, index + 1)
                        .join("/")}`
                }))
            )
        }
    }

    // Case: Content Pages
    if (slug && slug.length > 0) {
        breadcrumbs.push(
            ...slug.map((segment, index) => ({
                name: segment.charAt(0).toUpperCase() + segment.slice(1),
                url: `/${(slug ?? []).slice(0, index + 1).join("/")}`
            }))
        )
    }

    // Case: Product Pages (PDP)
    if (product) {
        let productBreadcrumbs: BreadcrumbItem[] = []
        if (product?.categoryUri) {
            productBreadcrumbs = product?.categoryUri
                .split("/")
                .reduce((acc, _, index, array) => {
                    const url = "/" + array.slice(0, index + 1).join("/")
                    return [
                        ...acc,
                        {
                            name: product.categoryName[index] || "",
                            url
                        }
                    ]
                }, [] as BreadcrumbItem[])
        }
        breadcrumbs.push(
            ...productBreadcrumbs.map(breadcrumb => ({
                ...breadcrumb,
                url: `/${CATEGORIES_URI}${breadcrumb.url}`
            }))
        )
    }

    return breadcrumbs
}
